import type { ReactNode } from 'react';
import AccessibleDialog from './AccessibleDialog';

interface AccessibleDrawerProps {
  isOpen: boolean;
  onClose: () => void;
  children: ReactNode;
  ariaLabel: string;
  panelClassName?: string;
}

/** A right-side modal drawer with the shared dialog's focus trap and restoration. */
export default function AccessibleDrawer({
  isOpen,
  onClose,
  children,
  ariaLabel,
  panelClassName = '',
}: Readonly<AccessibleDrawerProps>) {
  return (
    <AccessibleDialog
      isOpen={isOpen}
      onClose={onClose}
      ariaLabel={ariaLabel}
      className="fixed inset-0 z-[75] flex justify-end bg-black/40"
    >
      <aside className={`flex h-full w-full flex-col bg-white shadow-xl ${panelClassName}`}>
        {children}
      </aside>
    </AccessibleDialog>
  );
}
